import { Language } from "@/components/Inputs/LanguagePicker/Language.ts";
import { useIsCroatian } from "@/helpers/translation/useIsCroatian.ts";
import { RatePlan, RatePlanTranslation } from "@/helpers/types/types.ts";
import { getLocale } from "@/stores/ApolloClient/helpers/getLocale.ts";
import { useTranslation } from "react-i18next";

export interface GetRPTranslatedInfoResponse extends Pick<RatePlanTranslation, "description" | "name"> {
  translation?: RatePlanTranslation;
  getTranslateRPData: (rp: RatePlan) => {
    translation?: RatePlanTranslation;
    name: string;
    description?: string;
  };
}
/**
 * Retrieves translated information for a RatePlan (RP).
 * Default App language is "hr"
 *     - if it's hr return directly the entity values
 *     - if it's not hr, check if there is a translation for the current language and return it,
 *       if not return the entity values
 * @param {RatePlan} rp The RatePlan object to retrieve translated information for.
 * Returns an object containing the translated information
 */
export const useGetRPTranslated = (rp?: RatePlan): GetRPTranslatedInfoResponse => {
  const { i18n } = useTranslation();

  const isCroatian = useIsCroatian();

  const getTranslateRPData = (rp: RatePlan) => {
    const translation = rp.translations?.find((t) => t.language === getLocale(i18n.language as Language));
    const enFallback = rp.translations?.find((t) => t.language === "en");
    const name = isCroatian ? rp.name : translation?.name || enFallback?.name || rp.name;
    const description = isCroatian
      ? rp.description
      : translation?.description || enFallback?.description || rp.description;
    return { translation, name, description };
  };

  if (rp) {
    return { ...getTranslateRPData(rp), getTranslateRPData };
  }

  return { getTranslateRPData };
};
